<template>
  <div :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }">
    <div
      class="columns columns--cards"
      :style="{
        'background-color': useBackgroundColor,
        'padding-top': paddingTop + 'px',
        'padding-bottom': paddingBottom + 'px'
      }"
      @click="$emit('block:redirect')"
    >
      <info-balloon
        v-for="(block, index) in blocksByTag"
        :key="index"
        :fields="convertBlockFields(block)"
        :class="`column col-${Math.round(12/blocksByTag.length)} md-col-${blocksByTag.length > 1 ? 6 : 12}`"
      />
    </div>
  </div>
</template>

<script>
import InfoBalloon from '../info-balloon/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  components: { InfoBalloon },
  mixins: [staticBlockMixin]
}
</script>
